import { StatisticItem } from "../ReportStatistics";
import { VisitNotesReportData } from "./visitNotesReportApi";

export const getVisitNotesStatistics = (): StatisticItem[] => {
  return []
}

export const getJobTypes = (items: VisitNotesReportData[]): number[] => {
  const jobTypes = new Set<number>();
  items.forEach(item => {
    jobTypes.add(item.jobType);
  });

  return jobTypes.size ? Array.from(jobTypes) : [];
}

export const getFilteredItems = (items: VisitNotesReportData[], searchTerm: string, jobTypeSet: Set<number>): VisitNotesReportData[] => {
  if(items.length === 0) {
    return []
  }

  const filtered =  items.filter(x =>
    (x.name.toLowerCase().includes(searchTerm) 
      || x.customerDisplayName.toLowerCase().includes(searchTerm)) &&
    (jobTypeSet.size === 0 || jobTypeSet.has(x.jobType))
  )

  return filtered

};